import styled from "styled-components";

export const DupeListRow = styled.div`
  width: 100%;
  display: inline-block;
  margin-bottom: 10px;
`;

export const DupeListCol = styled.div`
  width: 50%;
  display: inline-block;
  vertical-align: text-top;
`;

export const DupeListRowHeader = styled.span`
  font-weight: bold;
`;
